"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Ignores the return value of a given function and returns the value of the
 * previous function instead.
 * @example
 * import { ignoreReturnFor } from 'promise-frites';
 *
 * Promise.resolve()
 *   .then(() => '1 value')
 *   .then(ignoreReturnFor(() => '2 value'))
 *   .then((value) => value === '1 value')); // true
 */
var ignoreReturnFor = exports.ignoreReturnFor = function ignoreReturnFor(fn) {
  return function (arg) {
    return Promise.resolve().then(function () {
      return fn(arg);
    }).then(function () {
      return arg;
    });
  };
};